// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoneyTickIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "MoneyTick/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.167 3.333H5.833c-2.5 0-4.166 1.25-4.166 4.167v2.967c0 .308.316.5.591.375a4.614 4.614 0 0 1 2.75-.342c2.192.392 3.8 2.425 3.742 4.65-.008.35-.058.692-.15 1.025-.067.258.142.5.408.5h5.159c2.5 0 4.166-1.25 4.166-4.167V7.5c0-2.917-1.666-4.167-4.166-4.167ZM10 12.083a2.084 2.084 0 1 1 .001-4.168A2.084 2.084 0 0 1 10 12.083Zm6.042-.416a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V8.333a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v3.334Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 11.667A3.332 3.332 0 0 0 .833 15c0 .625.175 1.217.484 1.717a3.308 3.308 0 0 0 2.85 1.616c1.216 0 2.275-.65 2.85-1.616.308-.5.483-1.092.483-1.717a3.332 3.332 0 0 0-3.333-3.333Zm1.641 3.058-1.775 1.642a.636.636 0 0 1-.425.166.618.618 0 0 1-.441-.183l-.825-.825a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l.4.4 1.333-1.234a.63.63 0 0 1 .884.034.63.63 0 0 1-.034.883Z"
}));
export default MoneyTickIcon;